/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import { m11ResearchStudyResourceChanged, selectM11ResearchStudyResource } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import StringEntry from "../../datatypeComponents/StringEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import jsonEquals from "../../functions/jsonEquals";
import CodeableConceptEntry, { simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import QuantityEntry, { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import ExpandToAddOrEdit from "../../components/ExpandToAddOrEdit";
import PositiveIntEntry from "../../datatypeComponents/PositiveIntEntry";
import { convertValueSetToCodeableConceptSet, yesOrNoCodeableConceptSet } from "../../dictionaries/THOandFHIRValueSets";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { validateStep } from "../../functions/validateM11ReportAPI";
import YesNoRadioCheckBoxSwitch from '../../components/YesNoRadioCheckBoxSwitch';
import m11LimitedSectionCodesValueSet from "../m11ReportFunctions/m11UDPsectionCodesValueSet";

const saveThisAmendmentChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    thisAmendmentState, setAlertModalState, setStartingThisAmendmentState) => {
    if (thisAmendmentState?.identifier) {
        let changesStates = {
            thisAmendmentState: thisAmendmentState
        };
        let response = await saveM11Changes(apiToken, 4, m11ResearchStudyFoi, changesStates);
        if (response?.success) {
            if (response.m11ResearchStudyResource) {
                dispatch(m11ResearchStudyResourceChanged(response.m11ResearchStudyResource));
            }
            setStartingThisAmendmentState(JSON.parse(JSON.stringify(thisAmendmentState)));
        } else {
            if (response.error) {
                alert(response.error);
            }
        }
    } else {
        alert("missing thisAmendmentState.identifier");
    }
};

const reasonForAmendmentCodeableConceptSet = [
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218497",
            "display": "Change in Standard Of Care Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218496",
            "display": "Change in Strategy Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218495",
            "display": "IMP Addition Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218501",
            "display": "Inconsistency and/or Error in the Protocol Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218499",
            "display": "Investigator/Site Feedback Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218492",
            "display": "IRB/IEC Feedback Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218494",
            "display": "Manufacturing Change Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218498",
            "display": "New Data Available (Other Than Safety Data) Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218491",
            "display": "New Regulatory Guidance Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218493",
            "display": "New Safety Information Available Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218502",
            "display": "Protocol Design Error Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218500",
            "display": "Recruitment Difficulty Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C218490",
            "display": "Regulatory Agency Request to Amend Amendment Reason"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C17649",
            "display": "Other"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C48660",
            "display": "Not Applicable"
        }]
    }
];

const reasonForAmendmentValueSet = [
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218497",
        "display": "Change in Standard Of Care Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218496",
        "display": "Change in Strategy Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218495",
        "display": "IMP Addition Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218501",
        "display": "Inconsistency and/or Error in the Protocol Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218499",
        "display": "Investigator/Site Feedback Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218492",
        "display": "IRB/IEC Feedback Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218494",
        "display": "Manufacturing Change Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218498",
        "display": "New Data Available (Other Than Safety Data) Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218491",
        "display": "New Regulatory Guidance Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218493",
        "display": "New Safety Information Available Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218502",
        "display": "Protocol Design Error Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218500",
        "display": "Recruitment Difficulty Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218490",
        "display": "Regulatory Agency Request to Amend Amendment Reason"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C17649",
        "display": "Other"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C48660",
        "display": "Not Applicable"
    }
];

const amendmentScopeValueSet = [
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C68846",
        "display": "Global"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C217026",
        "display": "Not Global"
    }
];

const previousAmendmentValueSet = [
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218486",
        "display": "First Protocol Amendment"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218487",
        "display": "Protocol Previously Amended, Details Presented"
    }
];

const scopeImpactScopeValueSet = [
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C68846",
        "display": "Globally"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C41065",
        "display": "Locally"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C218489",
        "display": "By Cohort"
    }
];

const M11AmendmentDetailEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [amendmentDetailEntryState, setAmendmentDetailEntryState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingAmendmentDetailEntry = {
            detail: "", rationale: "", section: ""
        };
        if (startingValue?.url === "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-amendment-detail" &&
            startingValue.extension.length
        ) {
            for (const extension of startingValue.extension) {
                if (extension.url === "detail" && extension.valueString) {
                    startingAmendmentDetailEntry.detail = extension.valueString;
                }
                if (extension.url === "rationale" && extension.valueString) {
                    startingAmendmentDetailEntry.rationale = extension.valueString;
                }
                if (extension.url === "section" && extension.valueCodeableConcept) {
                    startingAmendmentDetailEntry.section = extension.valueCodeableConcept;
                }
            }
        }
        setAmendmentDetailEntryState(JSON.parse(JSON.stringify(startingAmendmentDetailEntry)));
    }, []);

    useEffect((() => {
        if (Object.keys(amendmentDetailEntryState).length > 0) {
            let newAmendmentDetailEntry = {
                "extension": [],
                "url": "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-amendment-detail"
            };
            if (amendmentDetailEntryState.detail) {
                newAmendmentDetailEntry.extension.push({
                    "url": "detail",
                    "valueString": amendmentDetailEntryState.detail
                });
            }
            if (amendmentDetailEntryState.rationale) {
                newAmendmentDetailEntry.extension.push({
                    "url": "rationale",
                    "valueString": amendmentDetailEntryState.rationale
                });
            }
            if (amendmentDetailEntryState.section) {
                newAmendmentDetailEntry.extension.push({
                    "url": "section",
                    "valueCodeableConcept": amendmentDetailEntryState.section
                });
            }
            if (newAmendmentDetailEntry.extension.length > 0) {
                setResourceState(prevState => { return { ...prevState, [elementName]: newAmendmentDetailEntry }; });
            }
        }
    }), [amendmentDetailEntryState]);

    if (startCollapsedState) {
        return <div>
            <b>AMendment Change Item: </b>
            {(startingValue && amendmentDetailEntryState) &&
                <div style={{ marginLeft: "24px" }}>
                    <p><b>Description of Change: </b>{amendmentDetailEntryState.detail}</p>
                    <p><b>Brief Rationale for Change: </b>{amendmentDetailEntryState.rationale}</p>
                    <p><b>Section # and Name: </b>{simpleDisplayStringFromFHIRCodeableConcept(amendmentDetailEntryState.section)}</p>
                </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(amendmentDetailEntryState).length > 0) {
        return <div>
            <b>{fieldLabel}: </b>
            <div style={{ marginLeft: "24px" }}>
                <h4 style={{ marginBottom: "0px" }}>Enter the Description of Change.</h4>
                <StringEntry elementName='detail'
                    fieldLabel='Description of Change'
                    startingValue={amendmentDetailEntryState.detail}
                    setResourceState={setAmendmentDetailEntryState} />
                <h4 style={{ marginBottom: "0px" }}>Enter the Brief Rationale for Change.</h4>
                <StringEntry elementName='rationale'
                    fieldLabel='Brief Rationale for Change'
                    startingValue={amendmentDetailEntryState.rationale}
                    setResourceState={setAmendmentDetailEntryState} />
                <h4 style={{ marginBottom: "0px" }}>Enter Section # and Name.</h4>
                <CodeableConceptEntry elementName='section'
                    fieldLabel='' startingValue={amendmentDetailEntryState.section}
                    codeableConceptLevelValueSet={convertValueSetToCodeableConceptSet(m11LimitedSectionCodesValueSet)}
                    setResourceState={setAmendmentDetailEntryState} />
            </div>
        </div>
    }
};

const ScopeImpactEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [scopeImpactEntryState, setScopeImpactEntryState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingScopeImpactEntry = {
            numberPositiveInt: "", numberQuantity: "", scope: ""
        };
        if (startingValue?.url === "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-amendment-scope-impact" &&
            startingValue.extension.length
        ) {
            for (const extension of startingValue.extension) {
                if (extension.url === "number" && extension.valuePositiveInt) {
                    startingScopeImpactEntry.numberPositiveInt = extension.valuePositiveInt;
                }
                if (extension.url === "number" && extension.valueQuantity) {
                    startingScopeImpactEntry.numberQuantity = extension.valueQuantity;
                }
                if (extension.url === "scope") {
                    startingScopeImpactEntry.scope = extension.valueCodeableConcept;
                }
            }
        }
        setScopeImpactEntryState(JSON.parse(JSON.stringify(startingScopeImpactEntry)));
    }, []);

    useEffect((() => {
        if (Object.keys(scopeImpactEntryState).length > 0) {
            let newScopeImpactEntry = {
                "extension": [],
                "url": "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-amendment-scope-impact"
            };
            if (scopeImpactEntryState.numberPositiveInt) {
                newScopeImpactEntry.extension.push({
                    "url": "number",
                    "valuePositiveInt": scopeImpactEntryState.numberPositiveInt
                });
            } else if (scopeImpactEntryState.numberQuantity) {
                newScopeImpactEntry.extension.push({
                    "url": "number",
                    "valueQuantity": scopeImpactEntryState.numberQuantity
                });
            }
            if (scopeImpactEntryState.scope) {
                newScopeImpactEntry.extension.push({
                    "url": "scope",
                    "valueCodeableConcept": scopeImpactEntryState.scope
                });
            }
            if (newScopeImpactEntry.extension.length > 0) {
                setResourceState(prevState => { return { ...prevState, [elementName]: newScopeImpactEntry }; });
            }
        }
    }), [scopeImpactEntryState]);

    if (startCollapsedState) {
        return <div>
            <b>Approximate #/% Enrolled at Time of Sponsor Approval: </b>
            {(startingValue && scopeImpactEntryState) &&
                <div style={{ marginLeft: "24px" }}>
                    <span>Approximately {scopeImpactEntryState.numberPositiveInt ?
                        scopeImpactEntryState.numberPositiveInt
                        :
                        displayStringFromFHIRQuantity(scopeImpactEntryState.numberQuantity)} enrolled {
                            simpleDisplayStringFromFHIRCodeableConcept(scopeImpactEntryState.scope)
                        }</span>
                </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(scopeImpactEntryState).length > 0) {
        return <div>
            <b>{fieldLabel}: </b>
            <div style={{ marginLeft: "24px" }}>
                <h4 style={{ marginBottom: "0px" }}>Enter the approximate number of participants enrolled.</h4>
                <PositiveIntEntry elementName='numberPositiveInt'
                    fieldLabel='Number enrolled at time of approval'
                    startingValue={scopeImpactEntryState.numberPositiveInt}
                    setResourceState={setScopeImpactEntryState} marginTop={"0px"} />
                <h4 style={{ marginBottom: "0px" }}>If not entering a number, enter the approximate percentage of participants enrolled as a percentage of the expected total. Select % as the unit.</h4>
                <QuantityEntry elementName='numberQuantity'
                    fieldLabel='Percentage enrolled at time of approval'
                    startCollapsed={startCollapsed}
                    startingValue={scopeImpactEntryState.numberQuantity}
                    setResourceState={setScopeImpactEntryState} marginTop={"0px"} />
                <h4 style={{ marginBottom: "0px" }}>Enter Amendment Scope Enrollment Definition.</h4>
                <CodeableConceptEntry elementName='scope'
                    fieldLabel='' startingValue={scopeImpactEntryState.scope}
                    codeableConceptLevelValueSet={[
                        {
                            "coding": [{
                                "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                "code": "C68846",
                                "display": "Globally"
                            }]
                        },
                        {
                            "coding": [{
                                "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                "code": "C41065",
                                "display": "Locally"
                            }]
                        },
                        {
                            "coding": [{
                                "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                "code": "C218489",
                                "display": "By Cohort"
                            }]
                        }
                    ]} noWriteIn={true}
                    setResourceState={setScopeImpactEntryState} />
            </div>
        </div>
    }
};

const M11Step004Amendment = forwardRef(({ setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);
    const [hasOtherSecondaryReason, setHasOtherSecondaryReason] = useState(false);

    const [thisAmendmentState, setThisAmendmentState] = useState({
        "identifier": "", "previous": "", "scope": "", "country": [], "region": [],
        "siteIdentifierReferenceString": [], "approvalDate": "", "signature": "",
        "signatureUrlString": "", "signatureUrlUrl": "", "signatureMethod": "",
        "scopeImpact": [], "primaryReason": "", "otherPrimaryReason": "",
        "secondaryReason": [], "otherSecondaryReason": "", "summary": "",
        "substantialImpactSafety": "", "substantialImpactSafetyComment": "",
        "substantialImpactReliability": "", "substantialImpactReliabilityComment": "",
        "rationale": "", "descriptionMarkdown": "", "descriptionString": "", "details": []
    });
    const [startingThisAmendmentState, setStartingThisAmendmentState] = useState({
        "identifier": "", "previous": "", "scope": "", "country": [], "region": [],
        "siteIdentifierReferenceString": [], "approvalDate": "", "signature": "",
        "signatureUrlString": "", "signatureUrlUrl": "", "signatureMethod": "",
        "scopeImpact": [], "primaryReason": "", "otherPrimaryReason": "",
        "secondaryReason": [], "otherSecondaryReason": "", "summary": "",
        "substantialImpactSafety": "", "substantialImpactSafetyComment": "",
        "substantialImpactReliability": "", "substantialImpactReliabilityComment": "",
        "rationale": "", "descriptionMarkdown": "", "descriptionString": "", "details": []
    });

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(thisAmendmentState, startingThisAmendmentState)),
        async saveAllChanges() {
            await saveThisAmendmentChanges(dispatch, apiToken, m11ResearchStudyFoi,
                thisAmendmentState, setAlertModalState, setStartingThisAmendmentState);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource) {
            let startingAmendment = {
                "identifier": "", "previous": "", "scope": "", "country": [], "region": [],
                "siteIdentifierReferenceString": [], "approvalDate": "", "signature": "",
                "signatureUrlString": "", "signatureUrlUrl": "", "signatureMethod": "",
                "scopeImpact": [], "primaryReason": "", "otherPrimaryReason": "",
                "secondaryReason": [], "otherSecondaryReason": "", "summary": "",
                "substantialImpactSafety": "", "substantialImpactSafetyComment": "",
                "substantialImpactReliability": "", "substantialImpactReliabilityComment": "",
                "rationale": "", "descriptionMarkdown": "", "descriptionString": "", "details": []
            };
            if (m11ResearchStudyResource.extension?.length > 0) {
                for (const extension of m11ResearchStudyResource.extension) {
                    if (extension.url === "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-protocol-amendment") {
                        if (extension.extension.length > 0) {
                            for (const ext of extension.extension) {
                                if (ext.url === "identifier" && ext.valueIdentifier?.value) {
                                    startingAmendment.identifier = ext.valueIdentifier.value;
                                } else if (ext.url === "previous" && ext.valueCodeableConcept) {
                                    startingAmendment.previous = ext.valueCodeableConcept;
                                } else if (ext.url === "scope" && ext.valueCodeableConcept) {
                                    startingAmendment.scope = ext.valueCodeableConcept;
                                } else if (ext.url === "country" && ext.valueCodeableConcept) {
                                    startingAmendment.country.push(ext.valueCodeableConcept);
                                } else if (ext.url === "region" && ext.valueCodeableConcept) {
                                    startingAmendment.region.push(ext.valueCodeableConcept);
                                } else if (ext.url === "site" && ext.valueIdentifier) {
                                    startingAmendment.siteIdentifierReferenceString.push(ext.valueIdentifier.value);
                                } else if (ext.url === "site" && ext.valueReference) {
                                    startingAmendment.siteIdentifierReferenceString.push(ext.valueReference.display);
                                } else if (ext.url === "approvalDate" && ext.valueDate) {
                                    startingAmendment.approvalDate = ext.valueDate;
                                } else if (ext.url === "signature" && ext.valueSignature) {
                                    startingAmendment.signature = ext.valueSignature;
                                } else if (ext.url === "signatureUrl" && ext.valueString) {
                                    startingAmendment.signatureUrlString = ext.valueString;
                                } else if (ext.url === "signatureUrl" && ext.valueUrl) {
                                    startingAmendment.signatureUrlUrl = ext.valueUrl;
                                } else if (ext.url === "signatureMethod" && ext.valueString) {
                                    startingAmendment.signatureMethod = ext.valueString;
                                } else if (ext.url === "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-amendment-scope-impact" && ext.extension) {
                                    startingAmendment.scopeImpact.push(ext);
                                } else if (ext.url === "primaryReason" && ext.valueCodeableConcept) {
                                    startingAmendment.primaryReason = ext.valueCodeableConcept;
                                    if (ext.valueCodeableConcept.text) {
                                        startingAmendment.otherPrimaryReason = ext.valueCodeableConcept.text;
                                    }
                                } else if (ext.url === "secondaryReason" && ext.valueCodeableConcept) {
                                    startingAmendment.secondaryReason.push(ext.valueCodeableConcept);
                                    if (ext.valueCodeableConcept.coding?.[0]?.display === "Other") {
                                        setHasOtherSecondaryReason(true);
                                        if (ext.valueCodeableConcept.text) {
                                            startingAmendment.otherSecondaryReason = ext.valueCodeableConcept.text;
                                        }
                                    }
                                } else if (ext.url === "summary" && ext.valueString) {
                                    startingAmendment.summary = ext.valueString;
                                } else if (ext.url === "substantialImpactSafety" && ext.valueCodeableConcept) {
                                    startingAmendment.substantialImpactSafety = ext.valueCodeableConcept;
                                } else if (ext.url === "substantialImpactSafetyComment" && ext.valueString) {
                                    startingAmendment.substantialImpactSafetyComment = ext.valueString;
                                } else if (ext.url === "substantialImpactReliability" && ext.valueCodeableConcept) {
                                    startingAmendment.substantialImpactReliability = ext.valueCodeableConcept;
                                } else if (ext.url === "substantialImpactReliabilityComment" && ext.valueString) {
                                    startingAmendment.substantialImpactReliabilityComment = ext.valueString;
                                } else if (ext.url === "http://hl7.org/fhir/uv/clinical-study-protocol/StructureDefinition/m11-amendment-detail" && ext.extension) {
                                    startingAmendment.details.push(ext);
                                } else if (ext.url === "rationale" && ext.valueString) {
                                    startingAmendment.rationale = ext.valueString;
                                } else if (ext.url === "description" && ext.valueMarkdown) {
                                    startingAmendment.descriptionMarkdown = ext.valueMarkdown;
                                } else if (ext.url === "description" && ext.valueString) {
                                    startingAmendment.descriptionString = ext.valueString;
                                }
                            }
                        }
                        break;
                    }
                }
            }
            startingAmendment.loaded = true;
            setThisAmendmentState(startingAmendment);
            setStartingThisAmendmentState(startingAmendment);
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (thisAmendmentState.secondaryReason?.length > 0) {
            for (const concept of thisAmendmentState.secondaryReason) {
                if (concept.coding?.[0]?.display === "Other") {
                    setHasOtherSecondaryReason(true);
                }
            }
        }
    }, [thisAmendmentState.secondaryReason]);

    return <div>
        <h3>Enter Amendment Details</h3>
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 4 (Enter Amendment Details) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>{
                thisAmendmentState.loaded &&
                <div>
                    <h4 style={{ marginBottom: "0px" }}>{thisAmendmentState.identifier ? "Revise the Amendment Identifier (e.g., amendment number)." : "Enter an Amendment Identifier (e.g., amendment number) to open the data entry form, or proceed to Step 5 if there is no amendment to add."}</h4>
                    <div style={{ maxWidth: "600px" }}>
                        <StringEntry
                            elementName='identifier'
                            fieldLabel='Amendment Identifier'
                            startingValue={thisAmendmentState.identifier}
                            setResourceState={setThisAmendmentState} />
                    </div>
                    {thisAmendmentState.identifier && <>
                        <h4 style={{ marginBottom: "0px" }}>Select the Amendment Scope (Global or Not Global)</h4>
                        <YesNoRadioCheckBoxSwitch
                            thin={true} togglable={true} boxes={true}
                            alternativeValues={[
                                {
                                    "coding": [{
                                        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                        "code": "C68846",
                                        "display": "Global"
                                    }]
                                },
                                {
                                    "coding": [{
                                        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                        "code": "C217026",
                                        "display": "Not Global"
                                    }]
                                }
                            ]}
                            alternativeLabels={["Global", "Not Global"]}
                            elementName={'scope'}
                            startingValue={thisAmendmentState.scope || ""} setter={setThisAmendmentState}
                            boldOnSelect={true}
                        />
                        {thisAmendmentState.scope?.coding?.[0]?.code === "C217026" &&
                            <div>
                                <h4 style={{ marginBottom: "0px" }}>If Amendment Scope is Not Global, specify the Country(ies), Region(s), or Site(s) involved.</h4>
                                <ArrayEntry datatype='CodeableConcept'
                                    elementName='country' fieldLabel='Country Identifier'
                                    doNotShowFieldLabel={true}
                                    startingValue={thisAmendmentState.country}
                                    systemChoices={["urn:iso:std:iso:3166"]}
                                    systemChoicesOpen startCollapsed
                                    setResourceState={setThisAmendmentState} />
                                <ArrayEntry datatype='CodeableConcept'
                                    elementName='region' fieldLabel='Region Identifier'
                                    doNotShowFieldLabel={true}
                                    startingValue={thisAmendmentState.region}
                                    systemChoices={["urn:iso:std:iso:3166:-2"]}
                                    systemChoicesOpen startCollapsed
                                    setResourceState={setThisAmendmentState} />
                                <ArrayEntry datatype='string'
                                    elementName='siteIdentifierReferenceString' fieldLabel='Site Identifier'
                                    doNotShowFieldLabel={true}
                                    startingValue={thisAmendmentState.siteIdentifierReferenceString}
                                    startCollapsed
                                    setResourceState={setThisAmendmentState} />
                            </div>}
                        <h4 style={{ marginBottom: "0px" }}>Classify whether this is the First Protocol Amendment or Protocol Previously Amended.</h4>
                        <YesNoRadioCheckBoxSwitch
                            thin={true} togglable={true} boxes={true}
                            alternativeValues={[
                                {
                                    "coding": [{
                                        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                        "code": "C218486",
                                        "display": "First Protocol Amendment"
                                    }]
                                },
                                {
                                    "coding": [{
                                        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
                                        "code": "C218487",
                                        "display": "Protocol Previously Amended, Details Presented"
                                    }]
                                }
                            ]}
                            alternativeLabels={["First Protocol Amendment", "Protocol Previously Amended, Details Presented"]}
                            elementName={'previous'}
                            startingValue={thisAmendmentState.previous || ""} setter={setThisAmendmentState}
                            boldOnSelect={true}
                        />
                        <h4 style={{ marginBottom: "0px" }}>Define the Approximate #/% Enrolled at Time of Sponsor Approval</h4>
                        <ArrayEntry datatype='ScopeImpact'
                            elementName='scopeImpact' fieldLabel='Amount Enrolled by Scope'
                            doNotShowFieldLabel={true}
                            startingValue={thisAmendmentState.scopeImpact}
                            startCollapsed
                            setResourceState={setThisAmendmentState} />
                        <h4 style={{ marginBottom: "0px" }}>Select a Primary Reason for Amendment</h4>
                        <CodeableConceptEntry elementName='primaryReason' noWriteIn={true}
                            fieldLabel='' startingValue={thisAmendmentState.primaryReason}
                            codeableConceptLevelValueSet={reasonForAmendmentCodeableConceptSet}
                            setResourceState={setThisAmendmentState} />
                        {thisAmendmentState.primaryReason?.coding?.[0]?.display === "Other" && <>
                            <h5 style={{ marginBottom: "0px" }}>Provide explanation for Other</h5>
                            <StringEntry elementName='otherPrimaryReason'
                                fieldLabel='Other Primary Reason'
                                startingValue={thisAmendmentState.otherPrimaryReason}
                                setResourceState={setThisAmendmentState} />
                        </>}
                        <h4 style={{ marginBottom: "0px" }}>Select any Secondary Reasons for Amendment that apply.</h4>
                        <ArrayEntry datatype='CodeableConcept' elementName='secondaryReason' noWriteIn={true}
                            fieldLabel='Secondary Reason for Amendment'
                            doNotShowFieldLabel={true}
                            startingValue={thisAmendmentState.secondaryReason}
                            codeableConceptLevelValueSet={reasonForAmendmentCodeableConceptSet}
                            setResourceState={setThisAmendmentState} />
                        {hasOtherSecondaryReason && <>
                            <h5 style={{ marginBottom: "0px" }}>Provide explanation for Other</h5>
                            <StringEntry elementName='otherSecondaryReason'
                                fieldLabel='Other Secondary Reason'
                                startingValue={thisAmendmentState.otherSecondaryReason}
                                setResourceState={setThisAmendmentState} />
                        </>}
                        <h4 style={{ marginBottom: "0px" }}>Enter the Amendment Summary.</h4>
                        <StringEntry elementName='summary'
                            fieldLabel='Amendment Summary'
                            startingValue={thisAmendmentState.summary}
                            setResourceState={setThisAmendmentState} />
                        <h4 style={{ marginBottom: "0px" }}>Is this amendment likely to have a substantial impact on the safety or rights of the participants?</h4>
                        <YesNoRadioCheckBoxSwitch
                            thin={true} togglable={true} boxes={true}
                            elementName={'substantialImpactSafety'}
                            alternativeLabels={["Yes", "No"]}
                            alternativeValues={yesOrNoCodeableConceptSet}
                            startingValue={thisAmendmentState.substantialImpactSafety || ""} setter={setThisAmendmentState}
                        />
                        {(jsonEquals(thisAmendmentState.substantialImpactSafety, yesOrNoCodeableConceptSet[0])) &&
                            <div style={{ marginBottom: "0px" }}>
                                Briefly explain, why "yes"
                                <StringEntry elementName='substantialImpactSafetyComment'
                                    fieldLabel='Substantial Impact on Safety Comment'
                                    startingValue={thisAmendmentState.substantialImpactSafetyComment}
                                    setResourceState={setThisAmendmentState} marginTop={"0px"} />
                            </div>
                        }
                        <h4 style={{ marginBottom: "0px" }}>Is this amendment likely to have a substantial impact on the reliability and robustness of the data generated by the clinical trial?</h4>
                        <YesNoRadioCheckBoxSwitch
                            thin={true} togglable={true} boxes={true}
                            elementName={'substantialImpactReliability'}
                            alternativeLabels={["Yes", "No"]}
                            alternativeValues={yesOrNoCodeableConceptSet}
                            startingValue={thisAmendmentState.substantialImpactReliability || ""} setter={setThisAmendmentState}
                        />
                        {(jsonEquals(thisAmendmentState.substantialImpactReliability, yesOrNoCodeableConceptSet[0])) &&
                            <div style={{ marginBottom: "0px" }}>
                                Briefly explain, why "yes"
                                <StringEntry elementName='substantialImpactReliabilityComment'
                                    fieldLabel='Substantial Impact on Safety Comment'
                                    startingValue={thisAmendmentState.substantialImpactReliabilityComment}
                                    setResourceState={setThisAmendmentState} marginTop={"0px"} />
                            </div>
                        }
                        <h4 style={{ marginBottom: "0px" }}>Summarize the changes and rationale in text form if desired (if not using the table for Overview of Changes in the Current Amendment)</h4>
                        <StringEntry elementName='rationale'
                            fieldLabel='Overview of Changes in the Current Amendment'
                            startingValue={thisAmendmentState.rationale}
                            setResourceState={setThisAmendmentState} />
                        <h4 style={{ marginBottom: "0px" }}>Enter the changes in the current amendment for tabular presentation.</h4>
                        <ArrayEntry datatype='M11AmendmentDetail'
                            elementName='details' fieldLabel='Amendment Detail'
                            doNotShowFieldLabel={true}
                            startingValue={thisAmendmentState.details}
                            startCollapsed
                            setResourceState={setThisAmendmentState} /></>
                    }
                </div>
            }</>
        }
    </div>
});

const M11Step004AmendmentHelperText = <div>
    <h3>Enter Amendment Details</h3>
    <div style={{ textAlign: "left" }}>
        <p>If this is the original protocol, no action is needed. Proceed to Step 5.</p>
        <p>Enter an Amendment Identifier (e.g., amendment number) to open the data entry form.</p>
        <p>Select the Amendment Scope (Global or Not Global). If Amendment Scope is Not Global, specify the Country(ies), Region(s), or Site(s) involved. For Sites, you can use Identifier or Reference datatype.</p>
        <p>Classify whether this is the First Protocol Amendment or Protocol Previously Amended.</p>
        <p>Define the Approximate #/% Enrolled at Time of Sponsor Approval. Complete for Globally, Locally, and/or By Cohort for up to 3 values as needed.</p>
        <p>Select a Primary Reason for Amendment</p>
        <p>Select any Secondary Reasons for Amendment that apply.</p>
        <p>Enter the Amendment Summary. Briefly describe key changes. Changes that are included in the amendment but unrelated to the key changes do not need to be described here.</p>
        <p>Is this amendment likely to have a substantial impact on the safety or rights of the participants? If yes, briefly explain.</p>
        <p>Is this amendment likely to have a substantial impact on the reliability and robustness of the data generated by the clinical trial? If yes, briefly explain.</p>
        <p>Summarize the changes and rationale in text form if desired (if not using the table for Overview of Changes in the Current Amendment), but more often enter the details for each change in the current amendment to be converted into a tabular presentation.</p>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step004AmendmentValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 4, m11ResearchStudyFoi,
                setValidationCheckState);
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 4 (Enter Amendment Details) {validationCheckState.step04numberOfChecks} issues checked. {validationCheckState.step04numberPassed} passed. {validationCheckState.step04numberFailed} failed.</h4>
        {!validationCheckState.amendmentDetected && <h5>No amendment detected.</h5>}
        <p>If amendment, Amendment Identifier is present: {validationCheckState.resultCheckAmendmentIdentifier}</p>
        <p>If amendment, Amendment Scope is present and matches an allowed value: {validationCheckState.resultCheckAmendmentScope}</p>
        <p>If amendment and Amendment Scope is Not Global, a specification of country, region, or site is present: {validationCheckState.resultCheckNotGlobalSpecification}</p>
        <p>If amendment, First Protocol Amendment or Protocol Previously Amended is selected: {validationCheckState.resultCheckPriorAmendmentIndicator}</p>
        <p>If amendment, approximate number enrolled is present or approximate percentage is present (with unit of %): {validationCheckState.resultCheckApproximateNumber}</p>
        <p>If amendment, Amendment Scope Enrollment Definition is present and matches an allowed value: {validationCheckState.resultCheckAmendmentScopeEnrollmentDefinition}</p>
        <p>If amendment, Primary Reason for Amendment is present and matches an allowed value: {validationCheckState.resultCheckPrimaryReason}</p>
        <p>If Primary Reason for Amendment is Other, explanation is provided: {validationCheckState.resultCheckPrimaryReasonOtherExplained}</p>
        <p>If amendment, Secondary Reason for Amendment is present and matches allowed values: {validationCheckState.resultCheckSecondaryReason}</p>
        <p>If Secondary Reason for Amendment is Other, explanation is provided: {validationCheckState.resultCheckSecondaryReasonOtherExplained}</p>
        <p>If amendment, Amendment Summary is present: {validationCheckState.resultCheckAmendmentSummary}</p>
        <p>If amendment, response to 'Is this amendment likely to have a substantial impact on the safety or rights of the participants?' is present and matches an allowed value: {validationCheckState.resultCheckSafetyImpact}</p>
        <p>If Yes to Substantial Impact on Safety, explanatory text is provided: {validationCheckState.resultCheckSafetyImpactComment}</p>
        <p>If amendment, response to 'Is this amendment likely to have a substantial impact on the reliability and robustness of the data generated by the clinical trial?' is present and matches an allowed value: {validationCheckState.resultCheckReliabiltytImpact}</p>
        <p>If Yes to Substantial Impact on Reliability, explanatory text is provided: {validationCheckState.resultCheckReliabiltytImpactComment}</p>
        <p>If amendment, Amendment Detail is provided as text or table: {validationCheckState.resultCheckAmendmentDetail}</p>
        <p>If amendment detail with table, Section # and Name entries match an allowed value: {validationCheckState.resultCheckAmendmentDetailSectionCode}</p>
    </div>}  </div>
}

export default M11Step004Amendment;
export {
    M11Step004AmendmentHelperText, M11AmendmentDetailEntry, ScopeImpactEntry, M11Step004AmendmentValidationCheck,
    amendmentScopeValueSet, previousAmendmentValueSet, scopeImpactScopeValueSet, reasonForAmendmentValueSet
};